import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20atmosphere%20with%20soft%20gradient%20lighting%2C%20dark%20theater%20curtains%20with%20warm%20golden%20accents%2C%20elegant%20film%20projection%20aesthetic%2C%20artistic%20motion%20blur%2C%20deep%20rich%20red%20and%20warm%20amber%20tones%2C%20clean%20modern%20composition%2C%20minimalist%20cinema%20vibe&width=1600&height=1000&seq=hero-cinema-01&orientation=landscape"
          alt="小小影院高清观影氛围背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/20 text-accent-200 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-flashlight-line"></i>
              每日更新 · 无需注册
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight text-balance mb-4">
              小小影院 - 高清免费在线观看不缓冲
            </h1>

            <p className="text-lg md:text-xl text-accent-200 font-medium mb-6">
              热门电视剧、电影大全，流畅观影体验
            </p>

            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              小小影院是一个专注高清免费影视内容的在线平台，覆盖热门电视剧、电影大全、综艺动漫等丰富资源。
              无需注册即可在线观看不缓冲，每日更新最新剧集和电影，高清画质配合流畅播放，
              为您带来沉浸式的免费追剧体验。目前站内已有超过三万部高清片源，每天有超过百万影迷在这里找到心仪的内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-accent-300">{stat.value}</div>
                  <div className="text-xs md:text-sm text-background-300/70 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                立即观影
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 font-medium text-sm rounded-lg hover:bg-background-50/25 transition-colors whitespace-nowrap text-center cursor-pointer border border-background-50/20"
              >
                浏览片库
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20collage%20of%20film%20elements%2C%20warm%20golden%20light%20beams%2C%20abstract%20movie%20poster%20composition%2C%20elegant%20dark%20background%20with%20amber%20highlights%2C%20film%20strip%20texture%2C%20luxurious%20theater%20atmosphere%2C%20artistic%20minimalist%20design&width=900&height=675&seq=hero-visual-02&orientation=landscape"
                alt="小小影院主视觉 - 高清影视内容"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}